import { useCreateSubscriptionPortal } from '@/shared/api/generated/subscriptions';

export const useCreatePaymentMethodPortalSession = () => {
  return useCreateSubscriptionPortal();
};
